<template>
  <v-container class="mt-5">
    <v-layout row wrap justify-space-around v-if="error">
      <v-flex xs12 sm8 md7 lg5 xl4>
        <app-alert @dismissed="onDismissed" :text="error.message" id="signin_error"></app-alert>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-space-around>
      <v-flex xs12 sm8 md7 lg5 xl4>
        <v-card>
          <v-card-text>
            <v-container>
              <v-form v-model="valid" @submit.prevent="onFormSubmitted">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      prepend-icon="mail"
                      :label="$t('email')"
                      name="email"
                      id="email"
                      v-model="email"
                      type="email"
                      :disabled="userLoading"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      prepend-icon="lock"
                      :label="$t('password')"
                      name="password"
                      id="password"
                      v-model="password"
                      type="password"
                      :disabled="userLoading"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout align-baseline wrap>
                    <v-flex xl4></v-flex>
                    <v-flex xs12 sm8 xl5>
                      <v-layout justify-space-between>
                        <v-flex class="text-xs-right"><a class="linkText" @click.stop="showSuggestionDialog">{{ $t('contactUs') }}</a></v-flex>
                        <v-flex class="text-xs-right"><a class="linkText" @click.stop="showResetPasswordEmailDialog">{{ $t('forgotPassword') }}?</a></v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex class="text-xs-right">
                      <v-btn 
                          color="primary" 
                          type="submit"
                          id="submitSignin"
                          :loading="userLoading" 
                          :disabled="userLoading || !canSignin" 
                          >
                        {{ $t('signIn') }}
                      </v-btn>
                    </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <ResetPasswordEmailPopup v-model="resetPasswordEmailDialog"></ResetPasswordEmailPopup>
    <SuggestionsPopup
      v-model="suggestionDialog"
      v-if="suggestionDialog"
      :actionMethod="SubmitSuggestion"
    >
      <template v-slot:inputText>
        <div>
          <v-flex>{{ $t('suggestionsOrQuestions') }} </v-flex>
          <br />{{ $t('profileContact') }}
          <br />QQ: 3372450933
          <br />
          <br />{{ $t('or') }}
          <br />
          <br />
        </div>
      </template>
    </SuggestionsPopup>
  </v-container>
</template>

<script>
import ResetPasswordEmailPopup from './ResetPasswordEmailPopup.vue'
import SimpleTextPopup from './SimpleTextPopup'
import SuggestionsPopup from './SuggestionsPopup'

export default {
  name: 'Signin',
  components: {
    SimpleTextPopup,
    SuggestionsPopup,
    ResetPasswordEmailPopup
  },
  data () {
    return {
      valid: true,
      email: '',
      password: '',
      resetPasswordEmailDialog: false,
      suggestionDialog: false
    }
  },
  computed: {
    canSignin () {
      return this.email !== '' && this.password !== ''
    },
    userLoading () {
      return this.$store.getters.userLoading
    },
    error () {
      return this.$store.getters.error
    },
    user () {
      return this.$store.getters.user
    }
  },
  watch: {
    userLoading (value) {
      if (value === false) {
        if (this.$route.query.target && this.$route.query.target !== '_') {
          let { target, ...otherParams } = this.$route.query
          if (this.user?.isAdmin) {
            this.$router.push('/administrator')
          } else {
            this.$router.push({
              path: this.$route.query.target.replace('_', '/'),
              query: otherParams})
          }
        } else {
          if (this.user.isAdmin) {
            this.$router.push('/administrator')
          } else {
            this.$router.push('/')
          }
        }
      }
    }
  },
  beforeMount () {
    this.$store.dispatch('clearError')
    if (this.user && this.user.uid) {
      if (this.$route.query.target && this.$route.query.target !== '_') {
        let { target, ...otherParams } = this.$route.query
        this.$router.push({
          path: this.$route.query.target.replace('_', '/'),
          query: otherParams
        })
      } else {
        this.$router.push('/')
      }
    }
  },
  methods: {
    showResetPasswordEmailDialog () {
      this.resetPasswordEmailDialog = true
    },
    onFormSubmitted () {
      this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    showSuggestionDialog () {
      this.suggestionDialog = true
    },
    SubmitSuggestion (payload) {
      this.$store.dispatch('sendSuggestion', payload)
    }
  }
}
</script>

<style>
.linkText:hover {
  text-decoration: underline;
}

.thinBox .v-input__slot {
  border: 1px solid rgba(0,0,0,.54) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Signin.vue